import { createSlice } from '@reduxjs/toolkit';

export const APP_MODES = {
	EARTH_ROVERS: 'earth_rovers',
	ROBOCAPS: 'robocaps'
};

const initialState = {
	mode: APP_MODES.EARTH_ROVERS
};

const appModeSlice = createSlice({
	name: 'appMode',
	initialState,
	reducers: {
		setAppMode: (state, action) => {
			state.mode = action.payload;
		}
	}
});

export const { setAppMode } = appModeSlice.actions;

export default appModeSlice.reducer;
